export default {
  getSelectedTagIds: (state) => state.selectedTagIds
}
